/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';

// 工单列表
export var workOrderList = function workOrderList(param) {
  return request({
    url: '/workOrder/index/reviewActionList',
    method: 'post',
    data: param
  });
};

// 工单详情
export var workOrderInfo = function workOrderInfo(param) {
  return request({
    url: '/workOrder/index/actionShow',
    method: 'post',
    data: param
  });
};
export var actionReview = function actionReview(param) {
  return request({
    url: '/workOrder/index/actionReview',
    method: 'post',
    data: param
  });
};